import { Stack, Typography } from "@mui/material";
import logo from "../assets/svg/logo-full.svg";
import ContainerLoading from "../components/ContainerLoading";

const Contract = () => (
  <ContainerLoading sx={{ padding: 4 }}>
    <Stack justifyContent="center" width="100%" alignItems="center" my="$6">
      <img
        style={{ maxWidth: "350px", width: "100%", cursor: "pointer" }}
        onClick={() => window.open("https://fightgo.com.br/")}
        src={logo}
        alt="ícone de login"
      />
    </Stack>
    <Typography fontWeight="bold" fontSize="$9" textAlign="center">
      Contrato Fight GO
    </Typography>
    <br />
    <Typography fontWeight="bold" fontSize="$6" textTransform="uppercase">
      Termo de matrícula
    </Typography>
    <br />
    <Typography fontSize="$6">
      Pelo presente o CONTRATANTE Nome do aluno, inscrito no CPF/MF nº CPF do
      Aluno, responsável por Nome do anulo se caso possuir responsável, ambos,
      residentes na Endereço, CEP: CEP, e-mail: Email do aluno, telefone,
      celebra o presente contrato com ACADEMIA, inscrita no C.N.P.J nº CNPJ ou
      CPF, com endereço na ENDEREÇO.
    </Typography>
    <br />
    <Typography fontSize="$6">
      1. O CONTRATANTE, ao assinar o presente instrumento, confirma que leu e
      está de acordo com as normas de utilização e serviços descritas abaixo,
      bem como está ciente na condição de consumidor da aplicação da Lei nº
      8.078/1990.
    </Typography>
    <br />
    <Typography fontSize="$6">
      2. A CONTRATADA presta os serviços como academia de artes marciais
      MODALIDADES, tendo ciência o CONTRATANTE que os professores não são
      profissionais de educação física e não estão obrigados ao registro em
      órgão de classe especifica.
    </Typography>
    <br />
    <Typography fontSize="$6">
      3. Qualquer dúvida, reclamação ou sugestão deverá ser enviada para o
      e-mail da academia e ou através do telefone Telefone da academia.
    </Typography>
    <br />
    <Typography fontSize="$6">
      4. O CONTRATANTE, optará pelo plano que melhor atender as suas
      necessidades de acordo com as condições oferecidas. A opção será
      formalizada através de documento fornecido pela CONTRATADA, que fica
      fazendo parte integrante do presente contrato, devendo o CONTRATANTE
      manter os pagamentos em dia, independentemente da frequência, sob pena de
      rescisão contratual, proibição de frequentar as aulas e multa de 10% sobre
      o débito.
    </Typography>
    <br />
    <Typography fontSize="$6">
      5. Os menores de 18 (dezoito) anos, quando aplicável, assinaram este
      instrumento juntamente com seu responsável legal, respondendo este
      solidariamente por seus atos, omissões ou obrigações, renunciando a
      qualquer benefício de ordem e estando ciente que poderão ocorrer, mas não
      se limitando somente a isto, lesões, fraturas e luxações decorrentes da
      própria atividade física escolhida.
    </Typography>
    <br />
    <Typography fontSize="$6">
      6. O CONTRATANTE e/ou responsável declaram para os devidos fins que gozam
      de plena saúde física e mental para a realização da atividade física
      contratada dispensando a necessidade de declaração médica.
    </Typography>
    <br />
    <Typography fontSize="$6">
      7. Sempre que forem necessárias alterações nos horários dos profissionais
      e/ou aulas a CONTRATADA, sem qualquer direito a reembolso ou desconto na
      mensalidade, comunicará os alunos através do grupo de WhatsApp.
    </Typography>
    <br />
    <Typography fontSize="$6">
      8. A CONTRATADA não estará em funcionamento aos sábados, domingos e
      feriados oficiais, sendo que em nenhum dos casos, caberá ao CONTRATANTE a
      reposição desses dias e/ou devolução de valores.
    </Typography>
    <br />
    <Typography fontSize="$6">
      9. Fica garantido ao CONTRATANTE o direito ao afastamento médico pelo
      período máximo de 10 dias, desde que, comunique e apresente atestado
      médico na recepção no prazo de até 5 dias após a emissão do mesmo, com
      direito a suspensão do contrato. Caso não efetue a entrega do mesmo no
      prazo acima, o CONTRATANTE perderá o direito ao afastamento.
    </Typography>
    <br />
    <Typography fontSize="$6">
      10. O CONTRANTE concorda expressamente com o prazo máximo estipulado para
      afastamento da atividade, conforme estipulado no item 8, independentemente
      de indicação médica e/ou afastamento médico por prazo superior, devido a
      prática da própria atividade escolhida e riscos de lesões informados no
      item 5.
    </Typography>
    <br />
    <Typography fontSize="$6">
      11. A CONTRATADA não se responsabiliza por perda, furto, roubo ou extravio
      dos pertences pessoais esquecidos e/ou deixados no interior da academia.
    </Typography>
    <br />
    <Typography fontSize="$6">
      12. O presente contrato não será renovado automaticamente, devendo o
      CONTRATANTE, manifestar a intenção ao final do plano contratado, onde lhe
      serão apresentadas as condições.
    </Typography>
    <br />
    <Typography fontSize="$6">
      13. Em caso de rescisão contratual, antes do prazo ajustado, serão
      descontados 20% do saldo devedor a título de cláusula penal, calculados e
      cobrados na forma pro rata die e sobre o valor normal do plano contratado,
      ou seja, não serão considerados eventuais descontos concedidos no ato da
      contratação do plano escolhido com os valores devolvidos no prazo de 30
      dias.
    </Typography>
    <br />
    <Typography fontSize="$6">
      14. O CONTRATANTE autoriza expressamente a divulgação de imagens, vídeos e
      áudios nas redes sociais Facebook, instagram e assemelhados, bem como, a
      divulgação nos aplicativos de mensagens whatsapp, telegram e assemelhados,
      sem qualquer compensação monetária e/ou moral.
    </Typography>
    <br />
    <Typography fontSize="$6">
      15. O CONTRATANTE tem ciência que todos os custos com competições,
      seminários, graduação anual, filiação, faixas, luvas de boxe e certificado
      não estão incluídos no plano mensal e deverão ser adquiridos a parte.
    </Typography>
    <br />
    <Typography fontSize="$6">
      16. O presente contrato é firmado em caráter pessoal, irretratável e
      irrevogável, ficando eleito pelas partes o foro da comarca de Itu, para
      dirimir questões controversas oriundas do presente instrumento assinando o
      presente instrumento em 2 (duas) vias de igual teor.
    </Typography>
    <br />
    <Typography
      fontWeight="bold"
      fontSize="$6"
      textTransform="uppercase"
      textAlign="center"
    >
      Plano contratado
    </Typography>
    <br />
    <br />
    <Typography fontSize="$6">Plano contratado: Plano Contratado</Typography>
    <br />
    <Typography fontSize="$6">
      Data de início: ____/____/______{"                             "}
      Data de término: ____/____/______
    </Typography>
    <br />
    <Typography fontSize="$6">Valor do plano sem desconto: R$</Typography>
    <br />
    <Typography fontSize="$6">Valor do plano com desconto: R$</Typography>
    <br />
    <Typography fontSize="$6">Matrícula n º</Typography>
    <br />
    <Typography fontSize="$6">Forma de pagamento:</Typography>
    <br />
    <br />
    <Typography fontSize="$6">
      Data atual
      <br />
      Aceite dos termos
      <br />
      Tem que salvar o IP
    </Typography>
  </ContainerLoading>
);

export default Contract;
